import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from "@angular/core";

@Component({
  selector: "font-color-button",
  templateUrl: "font-color-button.component.html",
  styleUrls:['font-color-button.css'],
  encapsulation: ViewEncapsulation.None
})

export class FontColorButtonComponent implements OnInit {

  @Input() selectedColor: string;
  @Input() pickedColor: string;
  @Input() disable: boolean;
  @Output() onFontColorChange:EventEmitter<string> = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
  }

  triggerPickedFontChange(){
    this.selectedColor = this.pickedColor;
    this.onFontColorChange.emit(this.pickedColor);
  }

  triggerSelectedFontChange(){
    this.onFontColorChange.emit(this.selectedColor);
  }

}
